import React from 'react'
import _helpers from '@toasttab/shared/src/globals/_helpers'

interface HiddenFieldProps {
  formik: any
  postalCode: string | null
  countryCode: string | null
}

const HiddenFields = ({
  formik,
  postalCode,
  countryCode
}: HiddenFieldProps) => {
  return (
    <>
      <input
        type='hidden'
        name='GCLID__c'
        id='GCLID__c'
        value={formik.values.GCLID__c ?? ``}
      />
      <input
        type='hidden'
        name='Website_Source_Detail__c'
        id='Website_Source_Detail__c'
        value={formik.values.Website_Source_Detail__c ?? ``}
      />
      <input
        type='hidden'
        id='craftFieldsetSlug'
        name='craftFieldsetSlug'
        value={formik.values.craftFieldsetSlug}
      />
      <input
        type='hidden'
        id='Last_Blog_Seen__c'
        name='Last_Blog_Seen__c'
        value={formik.values.Last_Blog_Seen__c ?? ``}
      />
      <input
        type='hidden'
        id='Web_initiative__c'
        name='Web_initiative__c'
        value={formik.values.Web_initiative__c ?? ``}
      />
      <input
        type='hidden'
        id='Web_origin__c'
        name='Web_origin__c'
        value={formik.values.Web_origin__c ?? ``}
      />
      <input
        type='hidden'
        id='Web_detail__c'
        name='Web_detail__c'
        value={formik.values.Web_detail__c ?? ``}
      />
      <input
        type='hidden'
        name='Website_Source_Detail__c'
        id='Website_Source_Detail__c'
        value={formik.values.Website_Source_Detail__c ?? ``}
      />
      <input type='hidden' id='eI' name='eI' value={formik.values.eI ?? ``} />
      <input
        type='hidden'
        id='browserLanguage'
        name='browserLanguage'
        value={formik.values.browserLanguage ?? ``}
      />
      <input
        type='hidden'
        id='referrerURL'
        name='referrerURL'
        value={formik.values.referrerURL ?? ``}
      />
      <input
        type='hidden'
        id='returnURL'
        name='returnURL'
        value={formik.values.returnURL}
      />
      <input
        type='hidden'
        id='munchkinId'
        name='munchkinId'
        value={formik.values.munchkinId}
      />
      <input
        type='hidden'
        id='_mkt_trk'
        name='_mkt_trk'
        value={formik.values._mkt_trk}
      />
      <input
        type='hidden'
        id='mkoProgramName'
        name='mkoProgramName'
        value={formik.values.mkoProgramName}
      />
      <input
        type='hidden'
        id='pageFormSubmissionURL'
        name='pageFormSubmissionURL'
        value={formik.values.pageFormSubmissionURL ?? ``}
      />
      <input name='formid' type='hidden' value={formik.values.formid} />
      <input
        type='hidden'
        id='craftInferredCountry'
        name='craftInferredCountry'
        value={_helpers.getCountry(countryCode) ?? ``}
      />
      <input
        type='hidden'
        id='postalCode'
        name='postalCode'
        value={postalCode ?? ``}
      />
      <input type='hidden' id='fC' name='fC' value={formik.values.fC ?? ``} />
      <input
        type='hidden'
        id='gae'
        name='gae'
        value={formik.values.gae ?? ``}
      />
      <input
        type='hidden'
        id='reffering-page-url'
        name='referringPageURLText'
        value={formik.values.referringPageURLText}
      />
      <input
        type='hidden'
        id='craftJavascriptStatus'
        name='craftJavascriptStatus'
        value={formik.values.craftJavascriptStatus}
      />
      <input
        type='hidden'
        id='shownCalendly'
        name='shownCalendly'
        value={formik.values.shownCalendly}
      />
      <input
        type='hidden'
        id='recaptchaValid'
        name='recaptchaValid'
        value={formik.values.recaptchaValid}
      />
      <input
        type='hidden'
        name='progressiveEligible'
        id='progressiveEligible'
        value={formik.values.progressiveEligible}
      />
      <input
        type='hidden'
        id='appendVariantTest'
        name='appendVariantTest'
        value={formik.values.appendVariantTest}
      />
      <input
        type='hidden'
        id='craftFormLocation'
        name='craftFormLocation'
        value={formik.values.craftFormLocation}
      />
      <input
        type='hidden'
        id='action'
        name='action'
        value={`${process.env.GATSBY_FORM_ACTION_URL}`}
      />
    </>
  )
}

export default HiddenFields
